module.exports = __webpack_public_path__ + "img/emoji_54.b0b17ab1.png";